import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/registro_sanitario/producto';
import Producto from './ProductoList';

const ms2p = (state) => {
  return {
    ...state.rs_producto,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Producto);